var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoManagerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.96028C10.8259 8.14277 11.8565 9.17406 13.0397 10C11.8572 10.8259 10.8259 11.8565 10 13.0397C9.17406 11.8572 8.14352 10.8259 6.96028 10C8.14277 9.17406 9.17406 8.14352 10 6.96028ZM10 0C10 5.52279 5.52279 10 0 10C5.52279 10 10 14.4772 10 20C10 14.4772 14.4772 10 20 10C14.4772 10 10 5.52279 10 0Z",
    fill: "#FF335F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoManagerLogo);
export default __webpack_public_path__ + "static/media/co-manager-logo.939f3f49de21e0815912a600c228b71b.svg";
export { ForwardRef as ReactComponent };